module.exports = __webpack_public_path__ + "img/horizontal_7_3_8019.17578a14.png";